import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { InputFormField } from "../../../formfields/InputFormField";
import { QuickAddChildrenProps } from "../common/QuickAddWrapper";
import { FormButtons } from "../../FormButtons";
import { FormHeader } from "../../FormHeader";
import { useQuickAddSubmit } from "../common/useQuickAddHooks";
import { LabNotebook, labNoteBooksConstants, labNotebookFieldLabels } from "../../../../ELN/types/LabNotebook";
import { ProjectsVirtualizedSelectForm } from "../../EntityForms/formsVirtualized/ProjectsVirtualizedSelectForm";
import { TextareaFormField } from "../../../formfields/TextareaFormField";
import { LabNotebookFormValues } from "../../../../ELN/LabNotebooks/Forms/LabNotebookForm";
import { useCallback } from "react";

export const QuickAddLabNotebookForm = ({ onCreate, onCancel, initialValues }: QuickAddChildrenProps<LabNotebook>) => {
  const { onSubmit, loading } = useQuickAddSubmit<LabNotebook>({
    resource: labNoteBooksConstants.resource,
    onCreate: onCreate,
    onCancel: onCancel,
  });

  const FormSchema = yup.object().shape({
    name: yup.string().required("Notebook name is required").typeError("Notebook name is required"),
  });

  const entityToFormValues = useCallback((entity?: Partial<LabNotebook>) => {
    return !!entity
      ? ({
          ...entity,
        } as LabNotebookFormValues)
      : {};
  }, []);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm<LabNotebookFormValues>({
    defaultValues: entityToFormValues(initialValues),
    resolver: yupResolver(FormSchema),
  });

  const formValuesToEntity = useCallback(
    (entity: LabNotebookFormValues) => onSubmit({ ...entity } as LabNotebook),
    [onSubmit]
  );

  return (
    <>
      <FormHeader title="Add notebook" />

      <InputFormField
        id="name"
        label={labNotebookFieldLabels.name}
        errors={errors}
        register={register}
        autoFocus={true}
        required
        placeholder="Enter notebook name..."
      />

      <ProjectsVirtualizedSelectForm
        id="projects"
        label={labNotebookFieldLabels.projects}
        control={control}
        showControls
        horizontal
        isMulti
        allowCreateEntity
        filters={{ currentUserHasAddPermission: true }}
      />

      <TextareaFormField
        id="description"
        label={labNotebookFieldLabels.description}
        errors={errors}
        register={register}
        placeholder="Enter description..."
      />

      <FormButtons
        onClose={onCancel}
        onSubmit={handleSubmit(formValuesToEntity)}
        disabled={isSubmitting}
        errors={errors}
        submitButtonLabel="Create"
        loading={loading}
      />
    </>
  );
};
